import { NgModule, ApplicationRef } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { routes } from './app.routes';
import { HttpClientModule } from '@angular/common/http';
import {LibDrawBaseService} from "../../../lib-ui/src/shared/base/lib-draw-base.service";
import {DrawService} from "./shared/services/draw.service";


@NgModule({
  imports: [
    BrowserModule,
    RouterModule.forRoot(routes),
    HttpClientModule,
    AppComponent,
  ],
  providers: [    {
    provide: LibDrawBaseService, useClass: DrawService
  }],
})
export class AppModule {
  ngDoBootstrap(appRef: ApplicationRef) {
    appRef.bootstrap(AppComponent);
  }
}
